import { createContext } from 'react';

import { GetStepsDataReturn } from '@/utils/buildLog';

import BuildLogSummary from '../../types/BuildLogSummary';

type StructuredBuildLogContextValue = {
  execution?: BuildLogSummary['execution'];
  stepsData?: GetStepsDataReturn;
  stepToOpen?: string | null;
};

const StructuredBuildLogContext = createContext<StructuredBuildLogContextValue | null>(null);

export default StructuredBuildLogContext;
